import React, { useState } from 'react';
import { QuestRoute } from '../../api/QuestRoutes';
import { formatCurrency, generateId, shortHandDateTime } from '../../utility/functions';
import Row from '../../layout/Row';
import Button from '../../forms/Button';
import Col from '../../layout/Col';
import Heading from '../../forms/Heading';
import HamQuest from '../../api/HamQuestGiver';
import ModalFactory from '../../Modal';

const ManageItem = ({ orderId, orderCompleted, ...props }) => {
    const [completed, setCompleted] = useState(props.completed);

    const completeItem = () => {
        HamQuest.put(QuestRoute.fulfillment.editOrder(orderId), {
            productOrderId: props.productOrderId
        })
            .then(() => {
                setCompleted(!completed)
                props.refresh()
            })
            .catch(ModalFactory.catch)
    }

    return (
        <Row id={generateId()}>
            <span style={{ paddingLeft: '1em' }}>(x{props.quantity}) - {props.name}</span>
            {orderCompleted && <span>Fulfilled</span>}
            {!orderCompleted && props.appProductType !== 'GiftCard' && <Button onClick={completeItem}>{completed ? 'Completed (Undo)' : 'Complete Item'}</Button>}
        </Row>
    )
}

const ManageOrder = ({ ...props }) => (
    <Col style={{ width: '30vw' }}>
        <Row><b>Order ID:</b><span>{props.orderId}</span></Row>
        <Row><b>Invoice ID:</b><span>{props.invoiceId}</span></Row>
        <Row><b>Customer:</b><span>{props.customerName}</span></Row>
        <Row><b>Address:</b><span>{props.address}</span></Row>
        <Row><b>Ordered Date:</b><span>{shortHandDateTime(props.orderDate)}</span></Row>
        <Heading>Ordered Products</Heading>
        {props.products.map(f => <ManageItem refresh={props.refresh} orderId={props.orderId} orderCompleted={props.completed} {...f} />)}
        <Heading>Total {formatCurrency(props.total)}</Heading>
    </Col>
);



export default ManageOrder;
